/**
 * Icon asset metadata schema boundary.
 *
 * Food icon slugs are stored as plain text identifiers and intentionally do not
 * enforce filesystem-level foreign keys. Downstream consumers must tolerate
 * stale slugs and apply UI fallback behavior.
 *
 * @see `packages/assets/README.md`
 */
import { pgEnum, pgTable, primaryKey, text } from "drizzle-orm/pg-core";
import { temporalTimestamps } from "../../utils/sql";
export const iconType = pgEnum("icon_type", ["food"]);

export const icon = pgTable(
  "icon",
  {
    type: iconType("type").notNull(),
    slug: text("slug").notNull(),
    description: text("description"),
    ...temporalTimestamps,
  },
  (t) => [primaryKey({ name: "icon_pk", columns: [t.type, t.slug] })],
);
